import { AssetsProvider } from '../context/AssetsContext';

export const withAssets = (component: () => JSX.Element) => () =>
  <AssetsProvider>{component()}</AssetsProvider>;
